/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Channel_Not_Linked_ErrorInputs */

const he_account_delivery_channel_not_linked_error = /** @type {(inputs: Account_Delivery_Channel_Not_Linked_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הערוץ עדיין לא מחובר. חברו אותו קודם, ואז הפעילו.`)
};

const en_account_delivery_channel_not_linked_error = /** @type {(inputs: Account_Delivery_Channel_Not_Linked_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This channel is not linked yet. Link it first, then enable.`)
};

/**
* | output |
* | --- |
* | "This channel is not linked yet. Link it first, then enable." |
*
* @param {Account_Delivery_Channel_Not_Linked_ErrorInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_channel_not_linked_error = /** @type {((inputs?: Account_Delivery_Channel_Not_Linked_ErrorInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Channel_Not_Linked_ErrorInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_channel_not_linked_error(inputs)
	return en_account_delivery_channel_not_linked_error(inputs)
});